import type { Nullable } from "@shared-kernel/core/types/nullable";
import type { ROLES } from "@user-management-context/shared/domain/types/enums/roles";
import type { Notice } from "./notices";

export const visibleNotices = (notices: Notice[], activeRole: Nullable<ROLES>, now: Date): Notice[] => {
  if (!activeRole) return [];
  return notices.filter(notice => notice.roles.includes(activeRole) && now.getTime() <= notice.until.getTime());
};
